<!-- main app container -->

<router-outlet></router-outlet>
<app-snackbar></app-snackbar>